import { withRouter } from "react-router-dom";
import inscription from "./inscription"

export default withRouter(inscription);
